module.exports = __webpack_public_path__ + "static/media/info.f4f2c82d.svg";